// extracted by css-extract-rspack-plugin
export default {"JoinCell":"K1pCC","JoinConditionCell":"me1m3"};